<template>

  <el-notification
    :notification="notification"
    :module="$t('modules.wiki.title')"
    :date="notification.created_at"
    :title="$t('modules.wiki.notifications.content_shared', { content: notification.data.data.content_name })"
  >
    <div slot="actions">
      <el-notification-button
        :notification="notification"
        :callback="goToContent"
        :title="$t('modules.wiki.notifications.btn_content_shared')"
      />
    </div>
  </el-notification>

</template>

<script>

export default {
  tag: 'el-notification-wiki-content_shared',
  name: 'NotifWikiContentShared',
  props: {
    notification: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    goToContent (notification) {
      return this.$router.push({name: 'wiki.content', params: { world: this.world.id, content: notification.data.data.content_id }})
    },
  },
  computed: {
    world () {
      return this.$store.getters['auth/getWorld']
    },
  },
}
</script>

<style scoped lang="scss">

</style>
